import { Fragment } from "react";
import "./SmartAudit.css";
import { smartAudit } from "../../staticdata";

const SmartAudit = () => {
  return (
    <Fragment>
      <section className="smartaudit-style">
        <div className="container">
          <div className="smartaudit-services">
            <div className="container">
              <div
                className="section-title"
                data-aos="fade-down"
                data-aos-duration="800"
              >
                <h1 className="text-center">
                  <span className="title-gradient">Smart Contract</span>{" "}
                  Audit
                </h1>
                <p className="text-center">
                  Launch and maintain your applications with our expert smart
                  contract audit services. We offer the best
                  services in the industry with thorough code checking so that
                  your smart contracts are not subjected to any security
                  attacks.
                </p>
              </div>
              <div className="row gy-4">
                {smartAudit.map((services, index) => (
                  <div
                    className="col-md-6 d-flex"
                    key={services.id}
                    data-aos="zoom-in"
                    data-aos-delay={index * 100}
                  >
                    <div
                      className="service-item-premium 
                                d-flex flex-column 
                                flex-lg-row flex-md-row 
                                align-items-center 
                                align-items-lg-start 
                                align-items-md-start 
                                gap-3 p-4 w-100"
                    >
                      <div className="icon-ring-premium">
                        <img
                          src={services.icon}
                          alt="img not found"
                          style={{ width: "35px", height: "35px" }}
                        />
                      </div>
                      <div className="service-item-desc">
                        <h5 className="mb-1">{services.title}</h5>
                        <p className="text-light mb-0">
                          {services.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default SmartAudit;
